export default __webpack_public_path__ + "static/media/logo_new.567ece4b.svg";